/**
 * Injects a script with provided content into the document body
 * @param scriptBody - JavaScript code to be injected as a script
 * @returns void
 */
export const injectScript = (scriptBody: string): void => {
  if (!scriptBody) {
    return;
  }

  const scriptElement = document.createElement("script");
  scriptElement.type = "text/javascript";
  scriptElement.innerHTML = scriptBody;
  document.head.appendChild(scriptElement);
};
